import React from 'react';
import { VStack } from '@gluestack-ui/themed';
import FormField from '@/common/components/forms/FormField';

interface FormalCriteriaFormProps {
  isReadOnly?: boolean;
}

const FormalCriteriaForm: React.FC<FormalCriteriaFormProps> = ({ isReadOnly = false }) => (
  <VStack space="sm">
    <FormField
      name="evaluation.formalCriteria.wordcount"
      type="text"
      horizontal
      readonly={isReadOnly}
      label="Wordcount"
      placeholder="300"
      fieldSize="xs"
      fieldWidth={80}
      labelSize="xs"
      errorTextSize="2xs"
      rules={{
        required: 'Wordcount is required',
        validate: (value: string) => {
          const number = parseFloat(value);
          if (Number.isNaN(number) || number <= 0) {
            return 'Wordcount must be a positive number';
          }
          if (number > 5000) {
            return 'Wordcount must be less than 5000';
          }
          return true;
        },
      }}
    />

    <FormField
      name="evaluation.formalCriteria.wordcountTolerance"
      type="text"
      horizontal
      readonly={isReadOnly}
      label="Wordcount Tolerance (+/-)"
      placeholder="0.333"
      fieldSize="xs"
      fieldWidth={80}
      labelSize="xs"
      errorTextSize="2xs"
      rules={{
        required: 'Wordcount Tolerance is required',
        validate: (value: string) => {
          const val = parseFloat(value);
          if (Number.isNaN(val) || val < 0 || val > 1) {
            return 'Wordcount tolerance must be between 0 and 1';
          }
          return true;
        },
      }}
    />

    <FormField
      name="evaluation.formalCriteria.minInTextCitations"
      type="text"
      horizontal
      readonly={isReadOnly}
      label="Minimum in-text citations"
      placeholder="1"
      fieldSize="xs"
      fieldWidth={80}
      labelSize="xs"
      errorTextSize="2xs"
      rules={{
        required: 'Number of In-Text Citations required',
        validate: (value: string) => {
          const val = parseInt(value, 10);
          if (Number.isNaN(val) || val < 0) {
            return 'Number of In-Text Citations must be a positive number';
          }
          return true;
        },
      }}
    />
  </VStack>
);

export default FormalCriteriaForm;
